import { isDev } from "@/lib/utils";
import { StytchB2B } from "@stytch/react/b2b";
import { AuthFlowType, B2BProducts, StytchEventType } from "@stytch/vanilla-js";

const AuthenticatePage = () => {
  const config = {
    authFlowType: AuthFlowType.Discovery,
    products: [B2BProducts.emailMagicLinks, B2BProducts.passwords],
    sessionOptions: {
      sessionDurationMinutes: 600,
    },
  };

  return (
    <div className="flex items-center justify-center min-h-screen bg-gray-100">
      <div className="px-8 py-6 mt-4 text-left bg-white shadow-lg rounded-lg">
        <StytchB2B
          config={config}
          callbacks={{
            onEvent: async ({ type, data }) => {
              const baseDomain = import.meta.env.VITE_DOMAIN;

              if (
                type ===
                  StytchEventType.B2BDiscoveryIntermediateSessionExchange ||
                type === StytchEventType.B2BMagicLinkAuthenticate
              ) {
                if (isDev()) {
                  window.location.href = `${window.location.origin}`;
                  return;
                }

                const protocol = window.location.protocol;
                const url = `${protocol}//${data.organization.organization_slug}.${baseDomain}`;
                // const url = `${window.location.origin}`;
                window.location.href = url;
              }
            },
          }}
        />
      </div>
    </div>
  );
};

export default AuthenticatePage;
